/* eslint-disable react/no-multi-comp */
/* eslint-disable no-undef */
/* eslint-disable react/jsx-sort-props */
/* eslint-disable react/jsx-max-props-per-line */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { makeStyles } from '@material-ui/styles';
import { TableCell, Grid, DialogContentText } from '@material-ui/core';
import { Table, DialogDefault, CustomFilter } from '../../components';
import * as selectors from '../../store/controleFrequencia/reducer';
import * as actions from '../../store/controleFrequencia/actions';
import Formulario from './Formulario';
import { isNotAdmin } from 'utils';
import * as Roles from '../../constants/role';
import * as selectorsAuth from '../../store/auth/reducer';

import moment from 'moment';
import { formatWithDay } from 'utils/date-format';
moment.locale('pt-br');

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
}));

const defaultFilter = authData => ({ 
  inicio: moment().subtract(1, 'month').startOf('month').valueOf(),
  fim: moment().endOf('month').valueOf(),
  tipoControle: "FOLHA_PONTO",
  usuarioId: isNotAdmin(authData.role) ? [authData.id] : [],
})

const FolhaPonto = ({ folhaPontos, authData, exportControleFrequencia, deleteControleFrequencia, downloadControleFrequencia }) => {
  const [open, setOpen] = useState(false);
  const [openDownload, setOpenDownload] = useState(false);
  const [id, setId] = useState(null);
  const [titles] = useState(['Data', 'Ocorrência', 'Inspetor e Auxiliar', 'Total da Jornada', 'Hora Extra']);
  const classes = useStyles();
  const [localFilter, setLocalFilter] = useState({
      inicio: moment().subtract(1, 'month').startOf('month').valueOf(),
      fim: moment().endOf('month').valueOf(),
      tipoControle: "FOLHA_PONTO",
    });
  const [openExport, setOpenExport] = useState(false);
  const [reload, setReload] = useState(false);

  const renderRows = r => {
    return (
      <>
        <TableCell size="small"> {formatWithDay(r.data)} </TableCell>
        <TableCell size="small">{r.ocorrenciaNome}</TableCell>
        <TableCell size="small">
          <span style={{ fontWeight: 'bold', fontSize: 12 }}> Insp: </span>
          <span style={{ fontSize: 12 }}> {r.inspetorNome} </span>
          {r.inspetorAuxiliarNome && <>
            <br/>
            <span style={{ fontWeight: 'bold', fontSize: 12 }}> Insp. Aux: </span>
            <span style={{ fontSize: 12 }}> {r.inspetorAuxiliarNome} </span>
          </>}
        </TableCell>
        <TableCell>{r.jornadaTotal}</TableCell>
        <TableCell size="small">
          {r.horaExtraAutorizadoPorNome && <>
            <span style={{ fontWeight: 'bold', fontSize: 12 }}> Autorizado Por: </span>
            <span style={{ fontSize: 12 }}> {r.horaExtraAutorizadoPorNome} </span>
          </>}
        </TableCell>
      </>
    )
  }

  const onEdit = id => {
    setOpen(true);
    setId(id);
  }

  const onClose = isSave => {
    setOpen(false);
    setId(null);

    if (isSave) {
      setReload(!reload);
    }
  }

  const isAdmin = () => authData && (authData.role === Roles.ADMIN || authData.role === Roles.SUPER_ADMIN);

  const getHeaderActions = () => {
    const actions = [
      {
        title: "Exportar",
        onClick: () => setOpenExport(true)
      }
    ];

    // if (authData.email === VINICIUS_ADMIN_EMAIL) {
    //   actions.push({ 
    //     title: 'Download Zip',
    //     onClick: () => setOpenDownload(true)
    //   });
    // }

    return actions;
  }

  const onAdd = () => {
    setOpen(true);
    setId(null);
  }

  const onDelete = (id, callback) => deleteControleFrequencia(id, callback);

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <CustomFilter
            onFilter={filterData => setLocalFilter(filterData)}
            fields={[
              { field: "useDates", useDateTypes: false, useDateTypesReadOnly: true },
              { field: "useUsuarios", md: 6, xs: 6, multiSelect: true, disabled: (Roles.ADMIN !== authData.role && Roles.SUPER_ADMIN !== authData.role) },
              { field: "useOption", md: 6, xs: 6, code: "PONTO_OCORRENCIA", label: "Ocorrências", key: "ocorrenciaIds" },
            ]}
            defaultFilter={defaultFilter(authData)}
          />
        </Grid>
      </Grid>
      <Grid item xs={12} className={classes.root}>
        <Table
          rows={folhaPontos}
          titles={titles}
          headerTitle="Folha de Pontos"
          renderRows={renderRows}
          onAdd={onAdd}
          onEdit={onEdit}
          hasRowActions={isAdmin()}
          showDelete={isAdmin()}
          onDelete={onDelete}
          headerActions={getHeaderActions()}
          usePaginationApi
          paginationApi="pontos/filter"
          paginationUrl="folha-pontos-v2"
          filterData={localFilter}
          reload={!reload}
        />
        <Formulario
          id={id}
          open={open}
          onClose={onClose}
        />
      </Grid>
      <DialogDefault
        open={openExport}
        handlerCancel={() => setOpenExport(false)}
        handlerConfirm={() => exportControleFrequencia(localFilter, () => setOpenExport(false))}
        title="Confirmação"
        confirmMessage="Exportar"
      >
        <DialogContentText> Deseja exportar todas as informações filtradas? </DialogContentText>
      </DialogDefault>
      <DialogDefault
        open={openDownload}
        handlerCancel={() => setOpenDownload(false)}
        handlerConfirm={() => {
          downloadControleFrequencia(localFilter, () => { setOpenDownload(false) });
        }}
        title="Confirmação"
        confirmMessage="Sim"
        cancelMessage="Não"
      >
        <DialogContentText> Deseja baixar todas os arquivos das notas filtradas? </DialogContentText>
      </DialogDefault>
    </>
  );
};

const mapStateToProps = state => ({
  folhaPontos: selectors.getControleFrequenciais(state),
  authData: selectorsAuth.getAuth(state)
});

const mapDispatchToProps = dispatch => bindActionCreators({
  ...actions
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(FolhaPonto);